import { useTranslation } from "react-i18next";
import { getSourceScopeLabel } from "./workbenchModel";
import type { KnowledgeSource } from "./types";

export function RightRailSources({
  sources,
}: {
  sources: readonly KnowledgeSource[];
}): JSX.Element {
  const { t } = useTranslation();
  if (sources.length === 0) {
    return (
      <div className="teacher-rail-content">
        <p className="teacher-empty">
          {String(t("workbench.tabs.sourcesEmpty"))}
        </p>
      </div>
    );
  }
  return (
    <div className="teacher-rail-content teacher-stack">
      {sources.map((source) => (
        <article key={source.id} className="teacher-card">
          <div className="teacher-card__topline">
            <span className="teacher-card__title">{source.title}</span>
            <span className={`teacher-pill teacher-pill--${source.status}`}>
              {source.status}
            </span>
          </div>
          <span className="teacher-card__meta">
            {getSourceScopeLabel(source.scope)}
          </span>
          <p className="teacher-card__body">{source.detail}</p>
        </article>
      ))}
    </div>
  );
}
